(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('MisReportesEvaluativos', MisReportesEvaluativos);

    MisReportesEvaluativos.$inject = ['$resource'];

    function MisReportesEvaluativos ($resource) {
        var resourceUrl =  'apo/misreportes:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
